import service from '@/utils/request'
// 获取发票管理列表
export function getInvoiceList(param) {
	return service.request({
		method: 'POST',
		url: '/app/invoice/invoiceList',
		data: param
	})
}
// 获取发票信息
export function getInvoiceById(param) {
	return service.request({
		method: 'POST',
		url: '/app/invoice/invoiceById',
		data: param
	})
}
// 获取发票明细列表
export function getInvoiceMxList(param) {
	return service.request({
		method: 'POST',
		url: '/app/invoiceMx/invoiceMxList',
		data: param
	})
}

